// extracted by mini-css-extract-plugin
export default {"totalLiability":"styles_totalLiability__bCjCB","totalLiability__label":"styles_totalLiability__label__UVDY0","totalLiability__tooltip":"styles_totalLiability__tooltip__LThwn"};